// src/pages/ProfileOrders/ProfileOrders.jsx
import React, { useEffect, useState } from 'react';
import { fetchMyOrders, fetchOrderDetails, IMAGE_PATH } from '../../services/api';

const parseImgArr = (v) => (Array.isArray(v) ? v : []);

export default function ProfileOrders() {
    const [orders, setOrders] = useState([]);
    const [openId, setOpenId] = useState(null);
    const [details, setDetails] = useState({});
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');

    useEffect(() => {
        (async () => {
            try {
                // defaults to PAID per our API call
                const data = await fetchMyOrders();
                setOrders(data);
            } catch (e) {
                setErr(e.message || 'Failed to fetch orders');
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const toggle = async (order_pk) => {
        if (openId === order_pk) { setOpenId(null); return; }
        setOpenId(order_pk);
        if (!details[order_pk]) {
            const d = await fetchOrderDetails(order_pk);
            setDetails((prev) => ({ ...prev, [order_pk]: d }));
        }
    };

    if (loading) return <div style={{ padding: 24 }}>Loading orders…</div>;
    if (err) return <div style={{ padding: 24, color: 'crimson' }}>{err}</div>;

    return (
        <div style={{ maxWidth: 960, margin: '24px auto', padding: 16 }}>
            <h2>My Orders</h2>
            {!orders.length && <p>No paid orders yet.</p>}

            {orders.map((o) => (
                <div key={o.order_pk} style={{ border: '1px solid #eee', borderRadius: 8, padding: 16, marginBottom: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <div style={{ fontWeight: 600 }}>#{o.local_order_id}</div>
                            <div style={{ fontSize: 13, color: '#666' }}>Placed: {new Date(o.created_at).toLocaleString()}</div>
                            <div style={{ marginTop: 6 }}>
                                <span style={{ padding: '2px 8px', borderRadius: 12, background: o.status === 'PAID' ? '#d1fae5' : '#f3f4f6' }}>
                                    {o.status}
                                </span>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontWeight: 700 }}>₹{Number(o.amount).toLocaleString()}</div>
                            <button onClick={() => toggle(o.order_pk)} style={{ marginTop: 8 }}>View details</button>
                        </div>
                    </div>

                    {/* quick glance of first few item thumbnails if present from grouped getMyOrders */}
                    {!!o.items?.length && (
                        <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                            {o.items.slice(0, 3).map((it, idx) => (
                                <img
                                    key={idx}
                                    src={it.images?.length ? IMAGE_PATH + it.images[0] : '/placeholder.jpg'}
                                    alt={it.productName}
                                    style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6 }}
                                    onError={(e) => (e.currentTarget.src = '/placeholder.jpg')}
                                />
                            ))}
                        </div>
                    )}

                    {openId === o.order_pk && details[o.order_pk] && (
                        <div style={{ marginTop: 16, borderTop: '1px dashed #ddd', paddingTop: 16 }}>
                            <h4>Payment</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
                                <div><b>Status:</b> {details[o.order_pk].order.status}</div>
                                <div><b>Method:</b> {details[o.order_pk].order.payment_method || 'N/A'}</div>
                                <div><b>Cashfree Payment ID:</b> {details[o.order_pk].order.cf_payment_id || '—'}</div>
                                <div><b>Email:</b> {details[o.order_pk].order.customer_email}</div>
                                <div><b>Phone:</b> {details[o.order_pk].order.customer_phone}</div>
                                <div><b>Updated:</b> {new Date(details[o.order_pk].order.updated_at).toLocaleString()}</div>
                            </div>

                            <h4 style={{ marginTop: 12 }}>Items</h4>
                            {details[o.order_pk].items.map((it) => (
                                <div key={it.id} style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 10 }}>
                                    <img
                                        src={parseImgArr(it.images).length ? IMAGE_PATH + it.images[0] : '/placeholder.jpg'}
                                        alt={it.productName}
                                        style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 6 }}
                                        onError={(e) => (e.currentTarget.src = '/placeholder.jpg')}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: 600 }}>{it.productName}</div>
                                        <div style={{ fontSize: 12, color: '#666' }}>SKU: {it.sku || '—'}</div>
                                    </div>
                                    <div>x{it.quantity}</div>
                                    <div>₹{Number(it.unit_price).toLocaleString()}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
